import 'blockly/lua';
import * as HU from 'blockly/msg/hu';
import * as Blockly from 'blockly/core';

Blockly.setLocale(HU);
const blockly: any = Blockly;

//- define generators -//
blockly.Lua['sp_start'] = (block) =>
{
    block.setDeletable(false);
    return `player.Start() \n`;
}
blockly.Lua['sp_move'] = (block) =>
{
    let dir = block.getFieldValue('direction');
    return `player.Move('${dir}') \n`;
}
blockly.Lua['sp_turn'] = (block) =>
{
    let dir = block.getFieldValue('direction');
    return `player.Turn('${dir}') \n`;
}
blockly.Lua['sp_jump'] = (block) =>
{
    return `player.Jump() \n`;
    return null;
}
blockly.Lua['sp_bind'] = (block) =>
{
    let key = block.getFieldValue('key');
    let action = block.getFieldValue('action');
    return `player.BindButton('${key}', '${action}') \n`;
}

//- define blocks -//
blockly.defineBlocksWithJsonArray([
    {
        "type": "sp_start",
        "message0": "Futtatáskor",
        "nextStatement": null,
        "colour": 270,
        "tooltip": "",
        "helpUrl": ""
    },
    {
        "type": "sp_move",
        "message0": "Lépj %1",
        "args0": [
            {
                "type": "field_dropdown",
                "name": "direction",
                "options": [["előre", "FORWARD"], ["hátra", "BACKWARD"]]
            }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 290,
        "tooltip": "",
        "helpUrl": ""
    },
    {
        "type": "sp_turn",
        "message0": "Fordulj %1",
        "args0": [
            {
                "type": "field_dropdown",
                "name": "direction",
                "options": [["balra", "LEFT"], ["jobbra", "RIGHT"]]
            }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 290,
        "tooltip": "",
        "helpUrl": ""
    },
    {
        "type": "sp_bind",
        "message0": "%1 gomb nyomásakor %2",
        "args0": [
            {
                "type": "field_dropdown",
                "name": "key",
                "options": [["A", "A"], ["D", "D"], ["Space", "Space"], ["↑", "UpArrow"], ["←", "LeftArrow"], ["→", "RightArrow"]]
            },
            {
                "type": "field_dropdown",
                "name": "action",
                "options": [["balra", "E_MOVE_LEFT"], ["jobbra", "E_MOVE_RIGHT"], ["lövés", "E_FIRE"]]
            },
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": 220,
        "tooltip": "",
        "helpUrl": ""
    },
    {
        "type": "sp_jump",
        "message0": "Ugorj előre",
        "previousStatement": null,
        "nextStatement": null,
        "colour": 220,
        "tooltip": "",
        "helpUrl": ""
    }
]);

export { blockly, Blockly, HU };